import { normalizeGameCatalogItems } from './types';
import { fetchGamesByIds } from './fetch-games-by-ids';
import { getGamesByIdsKey, normalizeGameIds } from './games-by-ids-logic';
import type { GameIdInput } from './games-by-ids-logic';

export const getGamesByIds = async (
  locale: string,
  ids?: readonly GameIdInput[] | null
) => {
  const key = getGamesByIdsKey(locale, normalizeGameIds(ids).join(','));
  if (!key) return [];

  return normalizeGameCatalogItems(await fetchGamesByIds(key));
};
